import { useLayoutEffect, useState } from "react";
import { motion } from 'framer-motion';

const FullPageFloatingElements = () => {
    // حالة لتخزين الأبعاد الكاملة للصفحة
    const [pageDims, setPageDims] = useState({ width: 0, height: 0 });

    useLayoutEffect(() => {
        const updateDimensions = () => {
            // document.documentElement.scrollHeight هو الارتفاع الكلي للمستند
            const fullHeight = document.documentElement.scrollHeight;
            const fullWidth = document.documentElement.scrollWidth;
            if (fullHeight !== pageDims.height || fullWidth !== pageDims.width) {
                setPageDims({ width: fullWidth, height: fullHeight });
            }
        };

        // تأخير بسيط للسماح للمحتوى بالتحميل وحساب ارتفاعه الصحيح
        const timerId = setTimeout(updateDimensions, 200);

        window.addEventListener('resize', updateDimensions);
        // أضف مستمع للتمرير إذا كان المحتوى يتم تحميله ديناميكيًا أثناء التمرير
        window.addEventListener('scroll', updateDimensions);

        return () => {
            clearTimeout(timerId);
            window.removeEventListener('resize', updateDimensions);
            window.removeEventListener('scroll', updateDimensions);
        };
    }, [pageDims.height, pageDims.width]); // أعد الحساب إذا تغيرت الأبعاد

    return (
        <div
            dir='ltr'
            className="fixed top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none"
        >
            {pageDims.height > 0 && [...Array(100)].map((_, i) => ( // زدنا عدد العناصر للمساحة الأكبر
                <motion.div
                    key={i}
                    className="absolute w-4 h-4 bg-amber-400/30"
                    initial={{
                        x: Math.random() * pageDims.width,
                        y: Math.random() * pageDims.height, // استخدم الارتفاع الكامل للصفحة
                        opacity: [.4, .65, .75],
                    }}

                    transition={{
                        duration: Math.random() * 50 + 40,
                        repeat: Infinity,
                        repeatType: "reverse",
                    }}
                />
            ))}
        </div>
    );
};

export default FullPageFloatingElements;